export const checkInSubscription = async (pdfUI) => {
    const saleText = '联系销售';
    const link = 'https://www.foxitsoftware.cn/esign#sales';
    //
    // 判断是否为企业帐户
    const roleInfo = pdfUI.customs.getESignerRoleInfo();
    const enterpriseId = roleInfo ? roleInfo.enterpriseId : '';
    if (!enterpriseId) {
        alert('个人帐户不支持此功能，请切换企业帐户登录，若您尚未开通企业帐户，请联系销售为您创建企业信息。', saleText, link);
        return result(false);
    }

    // 判断是否有saml
    let samlResponse, jwtToken;
    let res = await pdfUI.customs.getSAMLResponse();
    if(res.stat !== 0){
        if (res.stat > 0 && res.stat < 10000) {
            // 获取jwtToken
            res = await pdfUI.customs.getJwtToken(enterpriseId);
            if (res.data && res.data.jwt) {
                jwtToken = res.data.jwt;
            } else {
                return result(false);
            }
        } else {
            return result(false);
        }
    } else {
        samlResponse = res.data && res.data.samlAssertion;
        if (!samlResponse) {
            // 获取jwtToken
            res = await pdfUI.customs.getJwtToken(enterpriseId);
            if (res.data && res.data.jwt) {
                jwtToken = res.data.jwt;
            } else {
                return result(false);
            }
        } else {
            // 判断归属
            const enterpriseUserRelation = await pdfUI.customs.getEnterpriseUser(enterpriseId);
            if(enterpriseUserRelation.state !== 0 || enterpriseUserRelation.userType !== 2){
                alert('当前登录信息未归属当前企业，请更换帐户重新登录');
                return result(false);
            }
        }
    }

    // 判断订阅信息
    res = await pdfUI.customs.getUserSubscription({ wardType: 1 });
    if (res.stat !== 0) {
        if (res.stat > 10000) {
            if (res.stat === 600094) {
                alert('对内签署服务尚未订阅，请联系销售为您所在的企业订阅该服务。', saleText, link);
            } else {
                alert('对内签署服务已过期，请联系销售为您所在的企业续订该服务。', saleText, link);
            }
        }
        return result(false);
    }
    const userSubscription = res.data;
    if (userSubscription.serverTime >= userSubscription.expreTime) {
        alert('对内签署服务已过期，请联系销售为您所在的企业续订该服务。', saleText, link);
        return result(false);
    }

    return result(true, samlResponse, userSubscription, jwtToken);

    function result(state = false, samlResponse = '', userSubscription = null, jwtToken = '') {
        return {
            state,
            samlResponse,
            jwtToken,
            userSubscription
        };
    }

    function alert(msg = '数据查询错误，请稍后重试', okText = '确认', link = undefined) {
        return pdfUI.alert(msg, undefined, undefined, 'warning', undefined, undefined, undefined, okText)
            .then((res) => {
                if (res !== 'cancel' && link) {
                    window.open(link);
                }
            });
    }
}

export function getBase64Image(imgUrl) {
    return new Promise((resolve, reject) => {
        const imgEle = document.createElement('img')
        imgEle.src = imgUrl;
        imgEle.crossOrigin = '';

        imgEle.onload = function(){
            const originWidth = imgEle.width;
            const originHeight = imgEle.height;
            const maxWidth = 300, maxHeight = 300;
            let targetWidth = originWidth, targetHeight = originHeight;
            if (originWidth > maxWidth || originHeight > maxHeight) {
                if (originWidth / originHeight > maxWidth / maxHeight) {
                    // 更宽，按照宽度限定尺寸
                    targetWidth = maxWidth;
                    targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                } else {
                    targetHeight = maxHeight;
                    targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                }
            }
            // const width = imgEle.width * 4;
            // const height = imgEle.height * 4;
            const canvas = document.createElement("canvas");
            canvas.width = targetWidth;
            canvas.height = targetHeight;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(imgEle, 0, 0, targetWidth, targetHeight);
            const ext = imgEle.src.substring(imgEle.src.lastIndexOf(".")+1).toLowerCase();
            const base64 = canvas.toDataURL("image/" + ext);
            imgEle.onload = null;
            resolve(base64);
        };
        imgEle.onerror = function(e) {
            console.error("gallery-tool -> getBase64Image function error: ", e)
            reject(e)
        }
    })
}
